document.addEventListener("DOMContentLoaded", function () {
    const intervalId = setInterval(() => {
        const recommendations = document.querySelector(".related-products");
        if (recommendations && recommendations.innerHTML.trim() !== "") {
            productRecSlider();
            clearInterval(intervalId);
        }
    }, 1000);
});

function productRecSlider() {
    const $productGrid = $('.product-grid');
    if ($productGrid.length > 0) {
        $productGrid.slick({
            dots: false,
            centerMode: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: false,
            arrows: false,
            responsive: [
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '60px',
                        dots: true,
                        arrows: false
                    }
                }
            ]
        });
    }
}


